/*
 * Copyright 2023 Neckar IT GmbH, Mössingen, Germany
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
package com.meistercharts.canvas

import kotlin.jvm.JvmInline

/**
 * Represents the index of a layer (during layout or paint).
 * The index can be used to determine the order of the layers.
 */
@JvmInline
value class LayerIndex(val value: Int) : Comparable<Int> {
  override fun toString(): String {
    return "$value"
  }

  override fun compareTo(other: Int): Int {
    return value.compareTo(other)
  }

  fun compareTo(other: LayerIndex): Int {
    return value.compareTo(other.value)
  }

  companion object {
    /**
     * Represents an unknown layer index.
     * Must not be used during layout/painting of a layer
     */
    val unknown: LayerIndex = LayerIndex(-1)
  }
}

